import React from 'react';
import { MdClose, MdPerson, MdPayment, MdCalendarToday, MdAttachMoney, MdCreditCard, MdCheckCircle } from 'react-icons/md';
import './CustomerOffcanvas.css';

const getCurrencySymbol = (currency) => {
  const currencyMap = {
    'USD': '$',
    'JPY': '¥',
    'EUR': '€',
    'GBP': '£',
    'SGD': 'S$',
    'HKD': 'HK$',
    'AUD': 'A$'
  };
  return currencyMap[currency?.toUpperCase()] || '$';
};

const formatAmount = (amount, currency) => {
  const currencyCode = currency?.toUpperCase();
  if (currencyCode === 'JPY') {
    return amount.toFixed(0);
  }
  return amount.toFixed(2);
};

const TransactionOffcanvas = ({ show, onClose, transaction }) => {
  if (!show || !transaction) return null;

  return (
    <div className="customer-offcanvas-backdrop" onClick={onClose}>
      <div className="customer-offcanvas" onClick={(e) => e.stopPropagation()}>
        <div className="customer-offcanvas-header">
          <div className="header-content">
            <div className="customer-avatar">
              <MdPayment size={24} />
            </div>
            <div>
              <h4 className="customer-name">
                Transaction Details
              </h4>
            </div>
          </div>
          <button className="close-btn" onClick={onClose}>
            <MdClose size={24} />
          </button>
        </div>

        <div className="customer-offcanvas-body">
          <div className="info-section">
            <h5 className="section-title">Customer Information</h5>
            
            <div className="info-item">
              <div className="info-icon">
                <MdPerson size={20} />
              </div>
              <div className="info-content">
                <span className="info-label">Customer Name</span>
                <span className="info-value">
                  {`${transaction?.user?.firstName || ''} ${transaction?.user?.lastName || ''}`.trim() || 'N/A'}
                </span>
              </div>
            </div>

            <div className="info-item">
              <div className="info-icon">
                <MdPerson size={20} />
              </div>
              <div className="info-content">
                <span className="info-label">Email</span>
                <span className="info-value">{transaction?.user?.email || 'N/A'}</span>
              </div>
            </div>
          </div>

          <div className="info-section">
            <h5 className="section-title">Payment Information</h5>
            
            <div className="info-item">
              <div className="info-icon">
                <MdAttachMoney size={20} />
              </div>
              <div className="info-content">
                <span className="info-label">Amount</span>
                <span className="info-value">{getCurrencySymbol(transaction?.currency || transaction?.plan?.currency)}{formatAmount(transaction?.amount, transaction?.currency || transaction?.plan?.currency)}</span>
              </div>
            </div>

            <div className="info-item">
              <div className="info-icon">
                <MdCreditCard size={20} />
              </div>
              <div className="info-content">
                <span className="info-label">Currency</span>
                <span className="info-value">{transaction?.currency?.toUpperCase() || 'N/A'}</span>
              </div>
            </div>

            <div className="info-item">
              <div className="info-icon">
                <MdCalendarToday size={20} />
              </div>
              <div className="info-content">
                <span className="info-label">Payment Date</span>
                <span className="info-value">{transaction.paidAt && !isNaN(new Date(transaction.paidAt)) ? new Date(transaction.paidAt).toLocaleDateString() : 'N/A'}</span>
              </div>
            </div>
          </div>

          <div className="info-section">
            <h5 className="section-title">Plan Information</h5>
            
            <div className="info-item">
              <div className="info-icon">
                <MdPayment size={20} />
              </div>
              <div className="info-content">
                <span className="info-label">Plan Name</span>
                <span className="info-value">{transaction?.plan?.name || 'N/A'}</span>
              </div>
            </div>

            {/* <div className="info-item">
              <div className="info-icon">
                <MdCalendarToday size={20} />
              </div>
              <div className="info-content">
                <span className="info-label">Plan Type</span>
                <span className="info-value">{transaction?.planType || 'N/A'}</span>
              </div>
            </div> */}

            {/* <div className="info-item">
              <div className="info-icon">
                <MdCalendarToday size={20} />
              </div>
              <div className="info-content">
                <span className="info-label">Start Date</span>
                <span className="info-value">{transaction.startDate && !isNaN(new Date(transaction.startDate)) ? new Date(transaction.startDate).toLocaleDateString() : 'N/A'}</span>
              </div>
            </div> */}

            {/* <div className="info-item">
              <div className="info-icon">
                <MdCalendarToday size={20} />
              </div>
              <div className="info-content">
                <span className="info-label">End Date</span>
                <span className="info-value">{transaction.endDate && !isNaN(new Date(transaction.endDate)) ? new Date(transaction.endDate).toLocaleDateString() : 'N/A'}</span>
              </div>
            </div> */}
          </div>

          {transaction?.couponApplied && (
            <div className="info-section">
              <h5 className="section-title">Coupon Information</h5>
              
              <div className="info-item">
                <div className="info-icon">
                  <MdCreditCard size={20} />
                </div>
                <div className="info-content">
                  <span className="info-label">Coupon Name</span>
                  <span className="info-value">{transaction?.couponName || 'N/A'}</span>
                </div>
              </div>

              <div className="info-item">
                <div className="info-icon">
                  <MdAttachMoney size={20} />
                </div>
                <div className="info-content">
                  <span className="info-label">Discount Amount</span>
                  <span className="info-value">
                    {transaction?.couponAmount ? 
                      `${getCurrencySymbol(transaction?.couponCurrency)}${formatAmount(transaction?.couponAmount, transaction?.couponCurrency)}` : 'N/A'
                    }
                  </span>
                </div>
              </div>
            </div>
          )}

          <div className="status-section">
            <h5 className="section-title">Status Information</h5>
            
            <div className="status-grid">
              <div className="status-card">
                <div className="status-icon verified">
                  <MdCheckCircle size={20} />
                </div>
                <div className="status-content">
                  <span className="status-label">Payment Status</span>
                  <span className={`status-badge ${transaction.status === 'succeeded' ? 'verified' : 'pending'}`}>
                    {transaction.status || 'Pending'}
                  </span>
                </div>
              </div>

              {/* <div className="status-card">
                <div className="status-icon verified">
                  <MdCheckCircle size={20} />
                </div>
                <div className="status-content">
                  <span className="status-label">Plan Status</span>
                  <span className={`status-badge ${transaction.planStatus ? 'verified' : 'pending'}`}>
                    {transaction.planStatus ? 'Active' : 'Inactive'}
                  </span>
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TransactionOffcanvas;